/**
 * Extracts a snippet of up to `maxLength` characters from an HTML string, centered on the <strong> tag.
 * The <strong> tag is preserved in the output, and the result is valid HTML.
 * If <strong> is not found, returns the first `maxLength` characters as plain text.
 */
export function extractSnippetWithStrong(
  html: string,
  maxLength = 30,
): {
  snippet: string;
} {
  const div = document.createElement("div");
  div.innerHTML = html;
  const strong = div.querySelector("strong");
  if (!strong) {
    // Fallback: just return the first maxLength chars as plain text
    return {
      snippet: "",
    };
  }

  // Get the full text content, and the text content of <strong>
  const fullText = div.textContent || div.innerText || "";
  const strongText = strong.textContent || "";

  // Find the position of the <strong> text in the full text
  const strongStart = fullText.indexOf(strongText);
  if (strongStart === -1) {
    // Should not happen, but fallback
    return {
      snippet: "",
    };
  }
  const strongEnd = strongStart + strongText.length;

  // Calculate how many chars to take before and after <strong>
  const tagLength = `<strong>${strongText}</strong>`.length;
  const charsAround = maxLength - tagLength;
  const before = Math.floor(charsAround / 2);
  const after = charsAround - before;

  // Get the substring before and after <strong>
  const beforeText = fullText.slice(Math.max(0, strongStart - before), strongStart);
  const afterText = fullText.slice(strongEnd, strongEnd + after);

  // Return the snippet with <strong> tag in the middle
  return {
    snippet: `...${beforeText}<strong>${strongText}</strong>${afterText}...`,
  };
}
